import schema from 'async-validator';
import {Notify} from 'vant';

/**
 * 根据校验条件校验输入数据
 * @param descriptor 校验条件
 * @param source 输入数据
 * @returns {Promise<any>} 校验结果
 */
export default function validate(descriptor, source) {
    console.log('--validate',descriptor,source);
    let validator = new schema(descriptor);
    let validated = new Promise((resolve, reject) => {
        validator.validate(source).then((res) => {
            console.log('--validate 123',res);
            // validation passed or without error message
            resolve('success');
            // eslint-disable-next-line no-unused-vars
        }).catch(({errors, fields}) => {
            console.log('--validate 456',errors,fields);
            console.log('--validate 789',errors.length,fields);

            if (errors) {
                if(errors[0].message instanceof Promise){
                    errors[0].message.then(res=>{
                        console.log('--error res 888',res);
                        if(!res){
                            console.log('--error res 888 111');
                            if(errors.length===1){
                                console.log('--error res 888 333');
                                resolve('success');
                            }else{
                                console.log('--error res 888 444');
                                errors.shift()
                                errors.length&&Notify(errors[0].message);
                            }
                        }else{
                            console.log('--error res 888 222');
                            Notify(res);
                        }
                    })
                }else{
                    Notify(errors[0].message);
                    reject('error');
                }

            }
        });
    });
    return validated;
}
